import React from 'react';
import PropTypes from 'prop-types';
import ExchangeFormTrip from './ExchangeFormTrip';
import formTripShape from '../../helpers/shapes';
import './styles.scss';

const ExchangeForm = ({ trips, searchInputConfiguration, canPartialExchange, canChangeBookingClass, canChangeCabinClass }) => {
  const handleCabinClassChange = updatedValue => {
    trips.forEach(trip => {
      trip.cabinClass.onChange(updatedValue);
    });
  };

  return (
    <div className="exchange-form">
      <div className="exchange-form__header">
        {I18n.t('components.flight.exchange.form.subheader')}
      </div>
      <div className="d-flex-column row-gap-12">
        {trips.map((trip, index) => (
          <ExchangeFormTrip
            key={trip.id.value}
            index={index}
            trip={trip}
            searchInputConfiguration={searchInputConfiguration}
            canPartialExchange={canPartialExchange}
            handleCabinClassChange={handleCabinClassChange}
            canChangeBookingClass={canChangeBookingClass}
            canChangeCabinClass={canChangeCabinClass}
          />
        ))}
      </div>
    </div>
  );
};

ExchangeForm.defaultProps = {
  canChangeBookingClass: false,
  canChangeCabinClass: false,
};

ExchangeForm.propTypes = {
  trips: PropTypes.arrayOf(PropTypes.shape(formTripShape)).isRequired,
  searchInputConfiguration: PropTypes.shape({}).isRequired,
  canPartialExchange: PropTypes.bool.isRequired,
  canChangeBookingClass: PropTypes.bool,
  canChangeCabinClass: PropTypes.bool,
};

export default ExchangeForm;
